<template>
    <div class="questionnaires">
        <design-2021-questionnaire-section-component
            v-for="(section, sectionindex) in questionnaireIn.sections"
            :key="section.id"
            :section-index="sectionindex"
            :questionnaire-section-in="section"
            @update-section="updateSection"
            @store-form="storeForm">
        </design-2021-questionnaire-section-component>

        <div class="store-questionnaire-changes">
            <b-button
                class="btn-save btn-store-questionnaire"
                variant="primary"
                @click="storeForm">
                {{ $t('common.save') }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-questionnaire-component',
    props: ['questionnaireIn', 'projectId'],
    data() {
        return {
            questionnaire: this.questionnaireIn,
        };
    },
    methods: {
        storeForm() {
            this.alert.saving();
            const data = {
                questionnaire: this.questionnaire,
                project_id: this.projectId,
            };
            this.axios.post(this.routes.questionnaireProjectSave(), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateSection(updatedSection) {
            this.questionnaire.sections = this.questionnaire.sections.map((section) => {
                if (section.id === updatedSection.id) {
                    section = updatedSection;
                }
                return section;
            });
        },
    },
};
</script>

<style scoped lang="scss">
.store-questionnaire-changes {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
